var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    y: 0.333252,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3254 20.3383C24.3254 22.3721 22.6903 24.0156 20.6668 24.0156C18.6433 24.0156 17.0082 22.3721 17.0082 20.3383C17.0082 18.3044 18.6433 16.661 20.6668 16.661C22.6903 16.661 24.3254 18.3044 24.3254 20.3383Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6668 28.8333C24.2743 28.8333 27.6366 26.6967 29.9769 22.9988C30.8967 21.5505 30.8967 19.116 29.9769 17.6677C27.6366 13.9698 24.2743 11.8333 20.6668 11.8333C17.0592 11.8333 13.6969 13.9698 11.3566 17.6677C10.4368 19.116 10.4368 21.5505 11.3566 22.9988C13.6969 26.6967 17.0592 28.8333 20.6668 28.8333Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewProduct);
export default __webpack_public_path__ + "static/media/view-product.e0fdb0eb1b8b5f74ce1bbafdf08ba0ae.svg";
export { ForwardRef as ReactComponent };